import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportByCreativeComponent from '../../../../utils/ReportByCreativeComponent/ReportByCreativeComponent';
import { statisticsByCreative } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsByCreativeSegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statisticsByCreative && statisticsByCreative.groupParamsSegment) || []}
        reportComponent={ReportByCreativeComponent}
        translationKey="statisticsByCreative"
    />
);

export default StatisticsByCreativeSegments;
